var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5;

function _taggedTemplateLiteralLoose(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }
  strings.raw = raw;
  return strings;
}

import styled from "styled-components";
export var StyledWrapper = styled.span(
  _templateObject ||
    (_templateObject = _taggedTemplateLiteralLoose([
      "\n  display: flex;\n  margin-bottom: 2.5rem;\n",
    ]))
);
export var StyledUl = styled.ul(
  _templateObject2 ||
    (_templateObject2 = _taggedTemplateLiteralLoose(["\n  list-style-type: none;\n"]))
);
export var StyledTitle = styled.span(
  _templateObject3 ||
    (_templateObject3 = _taggedTemplateLiteralLoose([
      "\n  margin-right: 0.5rem;\n  text-transform: uppercase;\n",
    ]))
);
export var StyledLine = styled.span(
  _templateObject4 ||
    (_templateObject4 = _taggedTemplateLiteralLoose([
      "\n  display: flex;\n  flex-grow: 1;\n  border-bottom: 1px solid #a39f9f;\n",
    ]))
);
export var StyledItems = styled.ul(
  _templateObject5 ||
    (_templateObject5 = _taggedTemplateLiteralLoose([
      "\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(17rem, 1fr));\n  grid-template-rows: 20rem;\n  grid-auto-rows: 20rem;\n  gap: 1.5rem;\n",
    ]))
);
